export default class Toggle {
    constructor(el) {
        this.el = el;
        this.toggleBody = this.el.querySelector('.toggle__body');
        this.toggleHeader = this.el.querySelector('.toggle__header');
        this.toggleBodyInner = this.el.querySelector('.toggle__bodyInner');
        this.startTime = false;
        this.isAnimating = false;
        this.isOpen = false;
        this.bindEvents();
    }

    bindEvents() {
        this.toggleHeader.addEventListener('click', () => this.toggle());
    }

    toggle() {
        if (this.isAnimating) {
            return;
        }

        this.isAnimating = true;
        let height = this.getHeight();
        let self = this;

        if (this.isOpen) {
            this.isOpen = false;
            this.el.classList.remove('is-open');
            window.requestAnimationFrame(function(timestamp) {
                self.startTime = timestamp || new Date().getTime();
                self.slideUp(timestamp, self.toggleBody, height, 250);
            });
        } else {
            this.isOpen = true;
            this.el.classList.add('is-open');
            window.requestAnimationFrame(function(timestamp) {
                self.startTime = timestamp || new Date().getTime();
                self.slideDown(timestamp, self.toggleBody, height, 250);
            });
        }
    }

    getHeight() {
        return this.toggleBodyInner.offsetHeight;
    }

    slideDown(timestamp, contentEl, dist, duration) {
        timestamp = timestamp || new Date().getTime();
        let self = this;
        let runtime = timestamp - this.startTime;
        let progress = runtime / duration;
        let height = (dist * progress).toFixed(2);
        progress = Math.min(progress, 1);

        contentEl.style.height = height + 'px';

        if (runtime < duration) {
            window.requestAnimationFrame(function(timestamp) {
                self.slideDown(timestamp, contentEl, dist, duration);
            });
        } else {
            contentEl.style.height = 'auto';
            self.isAnimating = false;
        }
    }

    slideUp(timestamp, contentEl, dist, duration) {
        timestamp = timestamp || new Date().getTime();
        let self = this;
        let runtime = timestamp - this.startTime;
        let progress = runtime / duration;
        let height = dist - (dist * progress).toFixed(2);

        progress = Math.min(progress, 1);

        contentEl.style.height = height + 'px';

        if (runtime < duration) {
            window.requestAnimationFrame(function(timestamp) {
                self.slideUp(timestamp, contentEl, dist, duration);
            });
        } else {
            contentEl.style.height = '';
            self.isAnimating = false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/toggle/toggle.js